import * as React from "react";
import OverlayModal from "./private/overlay-modal";
import { nonNull } from "common/Support";
import ReactDOM from "react-dom";
import { APP_MODAL_ROOT } from "../../../lib/constants";
import type { RenderEnvironment } from "common/components/types";

export interface HasOverlayProps {
    renderEnvironment: RenderEnvironment;
}

export interface HasOverlayState {
    overlayState?: "visible" | "hiding" | "hidden";
}

export default abstract class HasOverlayComponent<
    TProps extends HasOverlayProps,
    TState extends HasOverlayState
> extends React.Component<TProps, TState> {
    protected showOverlay() {
        this.setState({ overlayState: "visible" });
    }

    protected hideOverlay() {
        this.setState({ overlayState: "hiding" });
    }

    private onAnimationEnd = () => {
        if (this.state.overlayState === "hiding") {
            this.setState({ overlayState: "hidden" });
        }
    };

    protected shouldRenderPortal(): boolean {
        return this.state.overlayState === "visible" || this.state.overlayState === "hiding";
    }

    protected getPortal(content: React.ReactNode): React.ReactPortal | undefined {
        let portal: React.ReactPortal | undefined;

        const renv = this.props.renderEnvironment;

        if (this.state.overlayState !== "hidden" && this.state.overlayState !== undefined && renv !== undefined) {
            portal = ReactDOM.createPortal(
                <OverlayModal
                    renderEnvironment={renv as RenderEnvironment}
                    dismissed={this.state.overlayState === "hiding"}
                    onAnimationEnd={this.onAnimationEnd}>
                    {content}
                </OverlayModal>,
                nonNull(document.getElementById(APP_MODAL_ROOT))
            );
        }

        return portal;
    }

    public abstract render(): React.ReactNode;
}
